import { gql } from 'graphql-request';

export const FETCH_EPSIODE_QUERY = gql`
  query ($filter: EpisodeFilter) {
    episodes(filter: $filter) {
      __typename
      id
      title
      originalTitle
      image {
        list
        cover
        listClean
        sticker
        svodCover
        appCover
        channelSquare
        channelList
        square
        portrait
        logo
        verticalBanner
        mobileBanner
        desktopBanner
        banner4k
      }
      genres {
        id
        value
      }
      tags
      slug
      position
      showViewCount
      contents {
        ... on Episode {
          id
          title
          originalTitle
          duration
          contentOwner
          businessType
          viewCount {
            count
            formattedCount
          }
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
            svodCover
            sticker
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          eventLive
          tags
          introStartTime
          introEndTime
          episodeNumber
          billingType
          tier
          playDate
          seoTitle
          slug
          webUrl
          rating
          playedDuration
          video {
            url
            hlsUrl
            drmKey
            isDrm
          }
          tvShow {
            id
            title
            assetSubType
            originalTitle
          }
        }
      }
      nextUrl
      page
      size
      totalResults
    }
  }
`;
